import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { alpha } from "../../theme/tokens";
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    Collapse,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { getPipeSpecifications } from "../../services/budgets/BudgetService";

const PipeSpecificationsTable = () => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const [specs, setSpecs] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (open && specs.length === 0) {
            setLoading(true);
            getPipeSpecifications()
                .then((data) => setSpecs(data))
                .finally(() => setLoading(false));
        }
    }, [open, specs.length]);

    return (
        <Box sx={{ mt: 2, width: "100%" }}>
            <Button
                onClick={() => setOpen(!open)}
                endIcon={open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                sx={{
                    color: "primary.main",
                    textTransform: "none",
                    fontWeight: 600,
                    p: 0,
                    "&:hover": { backgroundColor: "transparent", textDecoration: "underline" },
                }}
            >
                {open ? "Ocultar" : "Ver"} tabela de diâmetros disponíveis
            </Button>

            <Collapse in={open} timeout="auto" unmountOnExit>
                <Box sx={{ mt: 1.5 }}>
                    {loading ? (
                        <Typography variant="caption" color="text.secondary">
                            {t("budgetForm.pipeSpecificationsTable.loading")}
                        </Typography>
                    ) : (
                        <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: 2 }}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={{ backgroundColor: "primary.main" }}>
                                        <TableCell sx={{ color: "#fff", fontWeight: 600 }}>DN</TableCell>
                                        <TableCell sx={{ color: "#fff", fontWeight: 600 }}>Diâmetro Exterior (mm)</TableCell>
                                        <TableCell sx={{ color: "#fff", fontWeight: 600 }}>Resultado n </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {specs.map((pipe, idx) => (
                                        <TableRow
                                            key={idx}
                                            sx={{
                                                backgroundColor: idx % 2 === 0 ? "transparent" : alpha.primary04,
                                            }}
                                        >
                                            <TableCell sx={{ fontWeight: 600, color: "var(--text-primary)" }}>
                                                {pipe.nominalDiameter}
                                            </TableCell>
                                            <TableCell sx={{ color: "var(--text-secondary)" }}>
                                                {pipe.outerDiameterMm}
                                            </TableCell>
                                            <TableCell sx={{ color: "var(--text-secondary)" }}>
                                                {pipe.nominalDiameter}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                </Box>
            </Collapse>
        </Box>
    );
};

export default PipeSpecificationsTable;
